export const ZOOM_TOGGLE_BUTTON_PORTAL_ID = "zoom-toggle-button-portal-id";

export const ZoomToggleButtonPortal: React.FC = () => {
  return <div id={ZOOM_TOGGLE_BUTTON_PORTAL_ID} />;
};
